import React from "react";

import {
  SelectProps,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import {
  StyledInputWrapper,
  StyledInputInputTitle,
  StyledInputRowWrapper,
  StyledInputOptional,
} from "./UI-Library.styles";

type StyledMUIMultiSelectProps = Omit<
  SelectProps<string[]>,
  "value" | "defaultValue" | "onChange" | "multiple" | "renderValue"
> & {
  fieldTitle: string;
  options: Array<{ label: string; value: string }>;
  selectedValues: string[];
  customOnChange?: (selected: string[]) => void;
  optional?: boolean;
};

const StyledMUIMultiSelect: React.FC<StyledMUIMultiSelectProps> = ({
  fieldTitle,
  options,
  selectedValues,
  customOnChange,
  optional,
  ...selectProps
}) => {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const { value } = event.target;
    const nextSelectedValues =
      typeof value === "string" ? value.split(",") : value;

    if (customOnChange) {
      customOnChange(nextSelectedValues);
    }
  };

  return (
    <StyledInputRowWrapper>
      <StyledInputWrapper>
        <StyledInputInputTitle>
          {`${fieldTitle} `}
          {optional && <StyledInputOptional>(optional)</StyledInputOptional>}
        </StyledInputInputTitle>
        <Select
          {...selectProps}
          style={{
            height: "44px",
            borderRadius: "16px",
            overflow: "hidden",
            whiteSpace: "text-overflow",
          }}
          multiple
          value={selectedValues}
          onChange={handleChange}
          renderValue={(selected) => selected.join(", ")}
          IconComponent={() => (
            <div style={{ fontSize: "30px" }}>
              <ArrowDropDownIcon
                fontSize="inherit"
                style={{ marginTop: "3px", marginRight: "3px" }}
              />
            </div>
          )}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                width: "inherit",
              },
            },
          }}
        >
          {options.map((option) => (
            <MenuItem
              style={{ whiteSpace: "normal" }}
              key={option.value}
              value={option.value}
            >
              <Checkbox checked={selectedValues.indexOf(option.value) > -1} />
              <ListItemText
                style={{ maxWidth: "90%" }}
                secondary={option.label}
              />
            </MenuItem>
          ))}
        </Select>
      </StyledInputWrapper>
    </StyledInputRowWrapper>
  );
};

export default StyledMUIMultiSelect;
